// extracted by mini-css-extract-plugin
export default {"wrapper":"header_wrapper__KnNAG","wrapper__logo":"header_wrapper__logo__8Z23P","custom-select-container":"header_custom-select-container__mUuRS"};